import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./i18n/LanguageContext";
import SEO from "./components/SEO";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Process from "./components/Process";
import WhyBE1 from "./components/WhyBE1";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <SEO />
        <div className="App relative" data-testid="be1-app">
          <Navbar />
          <main>
            <Hero />
            <About />
            <Services />
            <Projects />
            <Process />
            <WhyBE1 />
            <Contact />
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
